import { useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface AddCardFormProps {
  columnId: string;
  isActive: boolean;
  onAdd: (columnId: string, content: string) => void;
  onCancel: () => void;
  onActivate: () => void;
}

export const AddCardForm = ({ columnId, isActive, onAdd, onCancel, onActivate }: AddCardFormProps) => {
  const { t } = useTranslation();
  const [content, setContent] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (isActive && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [isActive]);

  const handleSubmit = () => {
    if (!content.trim()) return;
    onAdd(columnId, content);
    setContent('');
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  if (!isActive) {
    return (
      <button
        className="w-full mt-2 py-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-xl transition-colors text-sm font-medium"
        onClick={onActivate}
      >
        {t('kanban.addCard')}
      </button>
    );
  }

  return (
    <div className="mt-2">
      <textarea
        ref={textareaRef}
        className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FFD66B] focus:border-transparent text-sm"
        placeholder={t('kanban.addCardPlaceholder')}
        rows={3}
        value={content}
        onChange={(e) => setContent(e.target.value)}
        onKeyDown={handleKeyPress}
      />
      <div className="flex gap-2 mt-2">
        <button
          className="flex-1 bg-gray-900 text-white px-4 py-2 rounded-xl hover:bg-gray-800 transition-colors text-sm font-medium"
          onClick={handleSubmit}
        >
          {t('kanban.add')}
        </button>
        <button
          className="flex-1 bg-gray-100 text-gray-700 px-4 py-2 rounded-xl hover:bg-gray-200 transition-colors text-sm font-medium"
          onClick={onCancel}
        >
          {t('common.cancel')}
        </button>
      </div>
    </div>
  );
};
